import React from "react";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {IQuartileBarProps} from "./QuartileBarSVG";

interface IOwnProps {
    wholeBarWidthPX: number;
}

interface IProps extends IQuartileBarProps, IOwnProps {}

export const QuartileBarSVGText = (props: IProps) => {
    const isDotAtChartStart = props.dotDistanceFromLeftPX <= 0;
    const isDotAtChartEnd = props.dotDistanceFromLeftPX >= props.wholeBarWidthPX;

    return (
        <>
            <Text as="span" css={firstQuartileValue} variant="info_txt_1">
                {priceM2Format(props.firstQuartile)}
            </Text>
            <Text as="span" css={secondQuartileValue(props.dotDistanceFromLeftPX, isDotAtChartStart, isDotAtChartEnd)} variant="body_copy_2" strong>
                {priceM2Format(props.secondQuartile)}
            </Text>
            <Text as="span" css={thirdQuartileValue} variant="info_txt_1">
                {priceM2Format(props.thirdQuartile)}
            </Text>
            <Text as="span" css={firstQuartileDescription} variant="info_txt_2">
                poniżej rynku
            </Text>
            <Text as="span" css={secondQuartileDescription} variant="info_txt_2">
                średnia rynkowa
            </Text>
            <Text as="span" css={thirdQuartileDescription} variant="info_txt_2">
                powyżej rynku
            </Text>
        </>
    );
};

const quartileValue = css`
    top: 3.6rem;
    position: absolute;
`;

const quartileDescription = (theme: Theme) => css`
    position: absolute;
    color: ${theme.colors.gray[700]};
    bottom: 0;
`;

const firstQuartileValue = css`
    ${quartileValue};
    left: 25%;
    transform: translate(-50%, 0);
`;

const firstQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    left: 25%;
    transform: translate(-100%, 0);
`;

const secondQuartileValue = (avgDotPositionFromFirstQuartileInPX: number, isDotAtChartStart: boolean, isDotAtChartEnd: boolean) => css`
    position: absolute;
    top: 0;
    left: calc(${avgDotPositionFromFirstQuartileInPX + "px"});
    transform: translate(-50%, 0);
    ${isDotAtChartStart &&
    css`
        transform: translate(0, 0);
    `}

    ${isDotAtChartEnd &&
    css`
        transform: translate(-100%, 0);
    `}
`;

const secondQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    left: 50%;
    transform: translate(-50%, 0);
`;

const thirdQuartileValue = css`
    ${quartileValue};
    right: 25%;
    transform: translate(50%, 0);
`;

const thirdQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    bottom: 0;
    left: 75%;
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";

import {IQuartileBarProps} from "./QuartileBarSVG";

interface IOwnProps {
    wholeBarWidthPX: number;
}

interface IProps extends IQuartileBarProps, IOwnProps {}

export const QuartileBarSVGText = (props: IProps) => {
    const isDotAtChartStart = props.dotDistanceFromLeftPX <= 0;
    const isDotAtChartEnd = props.dotDistanceFromLeftPX >= props.wholeBarWidthPX;

    return (
        <>
            <Text as="span" css={firstQuartileValue} variant="info_txt_1">
                {priceM2Format(props.firstQuartile)}
            </Text>
            <Text as="span" css={secondQuartileValue(props.dotDistanceFromLeftPX, isDotAtChartStart, isDotAtChartEnd)} variant="body_copy_2" strong>
                {priceM2Format(props.secondQuartile)}
            </Text>
            <Text as="span" css={thirdQuartileValue} variant="info_txt_1">
                {priceM2Format(props.thirdQuartile)}
            </Text>
            <Text as="span" css={firstQuartileDescription} variant="info_txt_2">
                poniżej rynku
            </Text>
            <Text as="span" css={secondQuartileDescription} variant="info_txt_2">
                średnia rynkowa
            </Text>
            <Text as="span" css={thirdQuartileDescription} variant="info_txt_2">
                powyżej rynku
            </Text>
        </>
    );
};

const quartileValue = css`
    top: 3.6rem;
    position: absolute;
`;

const quartileDescription = (theme: Theme) => css`
    position: absolute;
    color: ${theme.colors.gray[700]};
    bottom: 0;
`;

const firstQuartileValue = css`
    ${quartileValue};
    left: 25%;
    transform: translate(-50%, 0);
`;

const firstQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    left: 25%;
    transform: translate(-100%, 0);
`;

const secondQuartileValue = (avgDotPositionFromFirstQuartileInPX: number, isDotAtChartStart: boolean, isDotAtChartEnd: boolean) => css`
    position: absolute;
    top: 0;
    left: calc(${avgDotPositionFromFirstQuartileInPX + "px"});
    transform: translate(-50%, 0);
    ${isDotAtChartStart &&
    css`
        transform: translate(0, 0);
    `}

    ${isDotAtChartEnd &&
    css`
        transform: translate(-100%, 0);
    `}
`;

const secondQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    left: 50%;
    transform: translate(-50%, 0);
`;

const thirdQuartileValue = css`
    ${quartileValue};
    right: 25%;
    transform: translate(50%, 0);
`;

const thirdQuartileDescription = (theme: Theme) => css`
    ${quartileDescription(theme)};
    bottom: 0;
    left: 75%;
`;
